import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['error']

  validate(event) {
    const checkbox = this.element.querySelector('.signature-is-checked')
    if (!checkbox || !checkbox.checked) {
      event.preventDefault()
      this.errorTarget.classList.remove('d-none')
    }
  }
}
